import camelcaseKeys from "camelcase-keys";
import translate from "@/i18n/translate";
import { Product } from "./interfaces/Interface";
import { ReportingYear } from "./interfaces/Interface";
import { useIntl } from "react-intl";
export function formatDate(date: string) {
  let ymd = date.split("T")[0].split("-");
  let year = ymd[0].split("");
  return ymd[1] + "/" + ymd[2] + "/" + year[2] + year[3];
}

export function formatDateFullYear(date: string) {
  let ymd = date.split("T")[0].split("-");
  return ymd[1] + "/" + ymd[2] + "/" + ymd[0];
}

export function formatDateUsToIso(date: string) {
  let mdy = date.split("T")[0].split("/");
  return mdy[2] + "-" + mdy[0] + "-" + mdy[1];
}

export function formatDateWithMonthAbbr(dateStr: string) {
  return new Date(dateStr).toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric"
  });
}

function currentDateWithTimeStamp() {
  const date = new Date();
  let month = String(date.getUTCMonth() + 1).padStart(2, "0");
  let day = String(date.getUTCDate()).padStart(2, "0");
  let year = String(date.getUTCFullYear());

  const hours = date.getUTCHours();
  let amOrPm = hours < 12 ? "AM" : "PM";
  let hour = tweleHourFormat(hours);
  let minutes = String(date.getUTCMinutes()).padStart(2, "0");

  return "".concat(
    month,
    day,
    year,
    "_",
    hour,
    minutes,
    "_",
    amOrPm,
    "_",
    "UTC"
  );
}

function tweleHourFormat(hours: number) {
  let hour = "";
  if (hours === 0 || hours === 12) {
    hour = "12";
  } else if (hours > 0 && hours <= 11) {
    hour = String(hours).padStart(2, "0");
  } else if (hours > 12) {
    hour = String(hours - 12).padStart(2, "0");
  }
  return hour;
}

export function downloadPDF(pdfFileBytes: string, fileTitle: string) {
  const PDFData = pdfFileBytes;
  const blob = base64ToStringBlob(PDFData, "application/pdf");
  const fileName = fileTitle + "_" + currentDateWithTimeStamp() + ".pdf";
  // For IE and Edge
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    let link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
function base64ToStringBlob(data: string, contentType: string) {
  var byteCharacters = atob(data);
  var byteArrays = [];
  var sliceSize = 512;
  contentType = contentType || "application/pdf";

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, {
    type: contentType
  });
}

export const getLoaderStatus = (
  loaderState: boolean,
  liveRegion: Element | null
) => {
  if (liveRegion && loaderState) {
    setTimeout(() => {
      liveRegion.textContent = "insights data is loading";
    }, 300);
  } else if (liveRegion && !loaderState) {
    setTimeout(() => {
      liveRegion.textContent = "insights data is ready to review";
    }, 300);
  }
};

export function camlizeKeys(result: any) {
  return camelcaseKeys(result, { deep: true, exclude: [/-/] });
}

export const NoResults = () => {
  return (
    <table className="data-table -shadow">
      <thead className="dataheader">
        <tr className="dataheaderrow">
          <th className="dataheadercell"></th>
        </tr>
      </thead>
      <tbody className="databody">
        <tr className="datarow">
          <td>
            <div className="empty-msg">
              <span className="heading">{translate("app.noResultFound")}</span>
              <div className="-message">
                {translate("app.drilldown.selectDifferentStatus")}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export const Table = (props: any) => {
  return <table className="data-table -shadow">{props.children}</table>;
};
export const TableHeader = (props: any) => {
  return (
    <thead className="dataheader">
      <tr className="dataheaderrow">
        {props.columns.map((column: string, index: number) => {
          return (
            <th
              className="dataheadercell"
              data-th={column}
              key={`column-${index}`}
            >
              {column}
            </th>
          );
        })}
        {!props.forCourseDetails && (
          <td className="dataheadercell" data-th="Email Link"></td>
        )}
      </tr>
    </thead>
  );
};

export const TableBody = (props: any) => {
  return <tbody className="databody">{props.children}</tbody>;
};

export const checkIfProductIntegrated = (
  integratedProducts: Product[] | null,
  productId: string
) => {
  return integratedProducts?.some((product: Product) => {
    return product.id === productId;
  });
};
export const checkIfSllProductIntegrated = (
  integratedProducts: Product[] | null
) => {
  return checkIfProductIntegrated(integratedProducts, "sll");
};

export const checkIfSseProductIntegrated = (
  integratedProducts: Product[] | null
) => {
  return checkIfProductIntegrated(integratedProducts, "sse");
};

export const checkIfFsProductIntegrated = (
  integratedProducts: Product[] | null
) => {
  return checkIfProductIntegrated(integratedProducts, "fs");
};
export const checkIfCesProductIntegrated = (
  integratedProducts: Product[] | null
) => {
  return checkIfProductIntegrated(integratedProducts, "ces");
};

export const checkIfCsProductIntegrated = (
  integratedProducts: Product[] | null
) => {
  return checkIfProductIntegrated(integratedProducts, "cs");
};

export const getCurrentReportingYear = (
  reportingYears: ReportingYear[]
): ReportingYear | null => {
  const today = new Date();
  return reportingYears.filter((ry) => {
    return new Date(ry.startDate) < today && new Date(ry.endDate) > today;
  })[0];
};

export const scrollToTop = (className: string) => {
  let element = document.querySelector(className);
  if (element) {
    element?.scrollIntoView();
  }
};

/**
 * Generic arrow key navigation handler for chart elements
 * @param event - Keyboard event
 * @param config - Configuration object containing:
 */
export function handleChartArrowNavigation(
  event: React.KeyboardEvent,
  config: {
    totalItems: number;
    currentIndex: number;
    itemRefs: React.MutableRefObject<(HTMLDivElement | null)[]>;
    containerRef?: React.MutableRefObject<any>;
    onNavigate: (newIndex: number) => void;
    onEscape?: () => void;
    onExit?: () => void;
  }
) {
  const { totalItems, currentIndex, itemRefs, containerRef, onNavigate, onEscape, onExit } = config;

  if (event.key === "ArrowRight") {
    event.preventDefault();
    const newIndex = currentIndex === -1 ? 0 : Math.min(currentIndex + 1, totalItems - 1);
    onNavigate(newIndex);

    if (itemRefs.current[newIndex]) {
      itemRefs.current[newIndex]?.focus();
    }
  } else if (event.key === "ArrowLeft") {
    event.preventDefault();
    const newIndex = currentIndex === -1 ? 0 : Math.max(currentIndex - 1, 0);
    onNavigate(newIndex);

    if (itemRefs.current[newIndex]) {
      itemRefs.current[newIndex]?.focus();
    }
  } else if (event.key === "Escape") {
    event.preventDefault();
    if (onEscape) {
      onEscape();
    }
    if (containerRef?.current) {
      (containerRef.current as HTMLDivElement).focus();
    }
  } else if (event.key === "Tab") {
    if (onExit) {
      onExit();
    }
  }
}

export const useFormatMessage = () => {
  const intl = useIntl();
  return (descriptor: { id: string }, values?: Record<string, any>) => {
    return intl.formatMessage(descriptor, values);
  };
}
